import { useEffect, useState } from "react";

export function useCountdown(target: string | null) {
  const targetMs = target ? new Date(target).getTime() : null;
  const [remaining, setRemaining] = useState(() =>
    targetMs === null ? 0 : Math.max(0, targetMs - Date.now())
  );

  useEffect(() => {
    if (targetMs === null) return;
    const tick = () => setRemaining(Math.max(0, targetMs - Date.now()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [targetMs]);

  const totalSeconds = Math.floor(remaining / 1000);
  return {
    ended: targetMs !== null && remaining <= 0,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
